import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import styles from './phone.module.scss';



const getRegexPhoneTemp = (countryName) => {
  switch (countryName) {
    case 'Jordan':
      return /^(\962)[3]{0,1}[7]{1}[7-9]{1}[0-9]{7}$/;
    case 'Pakistan':
      return /^(92)[0-9]{10}$/;
    case 'Saudi Arabia':
      return /^(966)[0-9]{9}$/;
    case 'United Arab Emirates':
      return /^(971)?(?:50|51|52|55|56|58|2|3|4|6|7|9)\d{7}$/;
    default:
      return /^(20)1[0125][0-9]{8}$/;
  }
};

const validatePhone = (value, countryName) => {
  const regexTemp = getRegexPhoneTemp(countryName);
  return value.match(regexTemp) ? '' : 'Please enter a valid number';
};

export function Phone(props) {
  const { name, value, onChange, error } = props;
  const [phoneError, setPhoneError] = React.useState(error);

  React.useEffect(() => {
    setPhoneError(error);
  }, [error]);

  return (
    <div className={styles['container']}>
      <PhoneInput
        inputProps={{
          name,
          required: true,
          autoFocus: false,
        }}
        onlyCountries={['eg', 'ae', 'sa', 'jo', 'pk']}
        containerClass={styles['phone-input-container']}
        inputClass={styles['phone-input']}
        dropdownClass={styles['countries-dropdown']}
        buttonClass={styles['flags-button-dropdown']}
        country={'eg'}
        disableDropdown={true}
        onChange={(phone) => {
         // e.target.value = '+' + value;
         //setPhoneError(validatePhone(value, name));
         return onChange("+"+phone);
        }}
      />
      {phoneError && <p>{phoneError}</p>}
    </div>
  );
}

